import { render, staticRenderFns } from "./MobileAccess.vue?vue&type=template&id=6ae87f2e&scoped=true"
var script = {}
import style0 from "./MobileAccess.vue?vue&type=style&index=0&id=6ae87f2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ae87f2e",
  null
  
)

export default component.exports